<!-- src/components/Applications/AfsalSereign/Steps/Step4.vue -->
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
  changeSteps?: () => void // optional callback if your wrapper listens on change
}>()

// Must be checked (true) validations
const rules = {
  umsokn: {
    afsalSereignFullu: { sameAs: sameAs(true) },
    rightMoves: { sameAs: sameAs(true) },
  },
}
const v$ = useVuelidate(rules, { umsokn })

function onChange() {
  props.changeSteps?.()
}

// Wrapper calls this before advancing
async function validate(): Promise<boolean> {
  await v$.value.$validate()
  return !v$.value.$error
}

defineExpose({ validate })
</script>

<template>
  <div v-if="umsokn">

    <v-row>
      <v-col>
        <h2 class="forms__header">
          {{ t('umsokn_afsal_sereign_step4_header1') }}
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <div class="checkbox-group">
          <v-checkbox
            v-model="umsokn.afsalSereignFullu"
            :readonly="props.disable"
            hide-details="auto"
            :label="`${t('umsokn_afsal_sereign_step4_afsala_rettindi')} ${umsokn.name} (${umsokn.ssn})`"
          />
          <div class="error__text" v-if="v$.umsokn.afsalSereignFullu.$error">
            {{ t('umsokn_afsal_sereign_step4_afsala_rettindi_error') }}
          </div>
        </div>

        <div class="checkbox-group">
          <v-checkbox
            v-model="umsokn.rightMoves"
            :readonly="props.disable"
            hide-details="auto"   
            :label="`${t('umsokn_afsal_sereign_step4_rettindi_faerist')} ${umsokn.spouseName} (${umsokn.spouseSSN})`"
          />
          <div class="error__text" v-if="v$.umsokn.rightMoves.$error">
            {{ t('umsokn_afsal_sereign_step4_rettindi_faerist_error') }}
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped lang="scss">
.m-b-40 { margin-bottom: 40px; }
.forms__header {
  color: #194458;
  font-weight: 900;
  font-size: 28px;
  line-height: 1.25;
  margin: 0 0 12px;
}
.error__text {
  color: #b00020; /* Vuetify default error color */
  font-size: 0.875rem;
  margin-top: 4px;
}
</style>
